import { fetchApi } from "./fetchApi";

export default {
  async list() {
    const response = await fetchApi({
      method: "get",
      url: "/api/jira/qa/import/In%20Documentation",
    });
    return response.data.result;
  },

  async create(issueKey: string, packId: number, templateType: string, applicationDropdownValueId?: number, primaryActivityDropdownValueId?: number, serviceAreaAttributeList?: number[], userRole?: string[]) {
    const data: Record<string, any> = { packId, templateType };
    if (applicationDropdownValueId) data.applicationDropdownValueId = applicationDropdownValueId;
    if (primaryActivityDropdownValueId) data.primaryActivityDropdownValueId = primaryActivityDropdownValueId;
    if (serviceAreaAttributeList && serviceAreaAttributeList.length) data.serviceAreaAttributeList = serviceAreaAttributeList;
    if (userRole && userRole.length) data.userRole = userRole;
    const response = await fetchApi({
      data,
      method: "post",
      url: `/api/releaseNote/jira/${issueKey}`,
    });
    return response.data;
  },
};
